goog.provide("shadow.js.shim.module$$mui$x_date_pickers_pro");
goog.provide("module$shadow_js_shim_module$$mui$x_date_pickers_pro");
shadow.js.shim.module$$mui$x_date_pickers_pro = shadow.js.nativeProvides["@mui/x-date-pickers-pro"] = shadow$bridge("@mui/x-date-pickers-pro");
module$shadow_js_shim_module$$mui$x_date_pickers_pro.default = shadow.js.shim.module$$mui$x_date_pickers_pro;
